module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expansion-panel"
  }, [_c('div', {
    staticClass: "ep-heading",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('div', {
    staticClass: "ep-expander-icon"
  }, [_c('v-icon', {
    staticClass: "collapse-button",
    class: {
      collapsed: _vm.collapsed
    },
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")])], 1), _vm._v(" "), _vm._t("heading", [_vm._v("\n            Details\n        ")])], 2), _vm._v(" "), _c('v-expand-transition', [(!_vm.collapsed) ? _c('div', {
    staticClass: "ep-body"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_vm._t("default", [_vm._v("\n            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Est molestias praesentium ea laboriosam obcaecati fugit, culpa, laborum ad sequi et iusto quasi natus sunt tempora vel incidunt dolorum veritatis voluptatibus!\n        ")])], 2)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-478d60e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ExpansionPanel.vue
// module id = 2533
// module chunks = 1